import { Button } from '@ads/components-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import {
  ExamFilters,
  ExamListTemplate,
  ExamTable,
  useDeleteExam,
  useExamFilters,
  useExamList,
} from '@/features/exam-management';

export const Route = createFileRoute('/_authenticated/exams/' as never)({
  component: ExamListPage,
});

function ExamListPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('examManagement');
  const { data, isLoading, totalCount, currentPage, totalPages } = useExamList();
  const { filters, updateFilters, applyFilters, setPage, resetFilters } = useExamFilters();
  const { deleteExam } = useDeleteExam();

  return (
    <ExamListTemplate
      headerActions={
        <div className="flex gap-mini">
          <Button
            hierarchy="secondary"
            size="md"
            onClick={() => void navigate({ to: '/question-library' })}
          >
            {t('breadcrumb.library')}
          </Button>
          <Button
            hierarchy="primary"
            size="md"
            onClick={() => void navigate({ to: '/exams/create' as never })}
          >
            {t('actions.create')}
          </Button>
        </div>
      }
      filterPanel={
        <ExamFilters
          filters={filters}
          onFiltersChange={updateFilters}
          onApply={applyFilters}
          onClear={resetFilters}
        />
      }
      table={
        <ExamTable
          data={data}
          isLoading={isLoading}
          totalCount={totalCount}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setPage}
          onView={id =>
            void navigate({
              to: '/exams/$id/preview' as never,
              params: { id: String(id) } as never,
            })
          }
          onEdit={id =>
            void navigate({ to: '/exams/$id' as never, params: { id: String(id) } as never })
          }
          onDelete={id => deleteExam(id)}
        />
      }
    />
  );
}
